import Api from '@/api/config/_api_config.js'
import cca_api from '@/api/api.js'

export default {

    getListeSourceDepense(){
        const promise = Api().get('/roles/source-depense');
        return promise.then((response) => response.data)
    },

    updateUserProfil(data) {
        const promise = Api().post('/users/update', data)
        return promise.then((response) => response.data)
    },

    updateUserPassword(data) {
        const promise = Api().post('/users/update/password', data)
        return promise.then((response) => response.data)
    },

    getRolePersonnels() {
        const promise = cca_api.clinique().get('/accessibilites/users/roles')
        return promise.then((response) => response.data)
    },

    getInfoCliniqueActive() {
        const promise = Api().get('/config/clinique')
        return promise.then((response) => response.data)
    },

    getCountDown() {
        const promise = cca_api.clinique().get('/countdown')
        return promise.then(response => response.data)
    },
}